import { memo, SVGProps } from 'react';

const Vector34Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg preserveAspectRatio='none' viewBox='0 0 170 3' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M0 0H170' stroke='#FBFBFB' strokeWidth={3} />
  </svg>
);
const Memo = memo(Vector34Icon);
export { Memo as Vector34Icon };
